import React, { Component } from "react";
import ErrorMsgBlockComponent from "../../Error/ErrorMessageBlock";
import { checkEmployeeIDLength } from "../../../helpers/GlobalFunctions";
import { actions } from "../../../helpers/messages";
import { MappingRoles } from "../../../helpers/constants";
import { convertUTCToLocalDateTime } from "../../../helpers/GlobalFunctions";
import { RolePrivileges } from "../../../shared/RolePrivileges"

class MappedUserDetails extends Component {
	constructor(props) {
		super(props);
		this.myFormRef = React.createRef();
	}

	/**
	 * @description Function to disable edit mode while restting the form
	 * @memberof MappedUserDetails
	 */
	cancelEdit = () => {
		this.myFormRef.reset();
		this.props.toggleEditMode();
	};

	/**
	 * @description Function to get user role
	 * @param user Row element for each user
	 */
	getUserRole(role) {
		if (role) {
			const userRole = MappingRoles.find((x) => x.userRole === role);
			return userRole ? userRole.specialLabel : role;
		}

		return "N/A";
	}

	render() {
		const { user, loading, editObj, handleInputChange, handleBlur, showErrorMsg, onEnterPress, showSuccessMsg, formErrors, saveUser, userSaveError, editMode, 
			toggleEditMode, handleCancel } = this.props;
		const userRole = user && user.daprole ? this.getUserRole(user.daprole) : "N/A";
		const isRoleEditable = editMode && userRole !== "Admin";
		return (
			<>
				{loading ? (
					<div className="loading-overlay-upload add-surgeon-overlay">
						<span>{actions.load}</span>
					</div>
				) : user ? (
					<div className="customer-fields surgeon-details" data-testid="SNDetails">
						<div className="add-user-container" >
							<div className="card-body py-0">
								<form onSubmit={onEnterPress} noValidate ref={(el) => (this.myFormRef = el)}>
									<div className="row">
										{showSuccessMsg ? (
											<div className="col-sm-12">
												<div className="customer-save-success-msg">
													<p>{showSuccessMsg}</p>
												</div>
											</div>
										) : ''}
										{showErrorMsg ? (
											<div className="col-sm-12">
												<div className="customer-save-error-msg">
													<ErrorMsgBlockComponent className="pb-4 m-0" errorObject={showErrorMsg} />
												</div>
											</div>
										) : ''}
									</div>
									<fieldset className="customer-fields reset-password p-0" disabled={!editMode} >
										<div className="row">
											<div className="col-sm-12">
												<div className="form-group row">
													<label htmlFor="firstName" className="col-sm-4 col-form-label shrink-label">First Name{editMode ? <span className="red">*</span> : ""}</label>
													<div className="col-sm-8">
														<input
															type="text"
															id="firstName"
															data-testid="firstName"
															autoComplete="off"
															maxLength={50}
															className={`form-control ${formErrors && formErrors.firstName ? "has-error" : ""}`}
															value={editObj && editObj.firstName ? editObj.firstName : ""}
															onChange={(e) => handleInputChange("firstName", e.target.value)}
														/>
														{formErrors && formErrors.firstName ? (
															<div className="customer-error-msg">
																<p>{formErrors.firstName}</p>
															</div>
														) : ''}
													</div>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-sm-12">
												<div className="form-group row">
													<label htmlFor="lastName" className="col-sm-4 col-form-label shrink-label">Last Name{editMode ? <span className="red">*</span> : ""}</label>
													<div className="col-sm-8">
														<input
															type="text"
															id="lastName"
															data-testid="lastName"
															autoComplete="off"
															maxLength={50}
															className={`form-control ${formErrors && formErrors.lastName ? "has-error" : ""}`}
															value={editObj && editObj.lastName ? editObj.lastName : ""}
															onChange={(e) => handleInputChange("lastName", e.target.value)}
														/>
														{formErrors && formErrors.lastName ? (
															<div className="customer-error-msg">
																<p>{formErrors.lastName}</p>
															</div>
														) : ''}
													</div>
												</div>
											</div>
										</div>

										<div className="row">
											<div className="col-sm-12">
												<div className="form-group row">
													<label htmlFor="email" className="col-sm-4 col-form-label shrink-label">Email{editMode ? <span className="red">*</span> : ""}</label>
													<div className="col-sm-8">
														<input
															type="text"
															id="email"
															data-testid="email"
															autoComplete="off"
															className={`form-control ${formErrors && formErrors.email ? "has-error" : ""}`}
															value={editObj && editObj.email ? editObj.email : ""}
															onChange={(e) => handleInputChange("email", e.target.value)}
															onBlur={(e) => handleBlur("email", e.target.value)}
														/>
														{formErrors && formErrors.email ? (
															<div className="customer-error-msg">
																<p>{formErrors.email}</p>
															</div>
														) : ''}
													</div>
												</div>
											</div>
										</div>
									</fieldset>
									<div className="row">
										<div className="col-sm-12">
											<div className="form-group row">
												<label htmlFor="role" className="col-sm-4 d-flex align-items-center col-form-label shrink-label">
													<RolePrivileges />
													Role{isRoleEditable && <span className="red">*</span>}
												</label>
												<div className="col-sm-8">
													{isRoleEditable ? (
														<select
															id="role"
															data-testid="role"
															defaultValue={editObj && editObj.role ? editObj.role : ""}
															className={`form-select ${formErrors && formErrors.role ? "has-error" : ""}`}
															onChange={(e) => handleInputChange("role", e.target.value)}>
															<option value="">Select a role</option>
															{MappingRoles.filter(x => !x.hideFromAddUser).map(role =>
																<option key={`option-${role.userRole}`} value={role.userRole}>{role.specialLabel}</option>
															)}
														</select>
													) : (
														<span className="form-control disabled">{userRole}</span>)}
													{formErrors && formErrors.role ? (
														<div className="customer-error-msg">
															<p>{formErrors.role}</p>
														</div>
													) : ""}

												</div>
											</div>
										</div>
									</div>
									<fieldset disabled={!editMode}>
										<div className="row">
											<div className="col-sm-12">
												<div className="form-group row">
													<label htmlFor="employeeID" className="col-sm-4 col-form-label shrink-label">Employee ID{editMode ? editMode : ""}</label>
													<div className="col-sm-8">
														<input
															type="number"
															id="employeeID"
															data-testid="employeeID"
															pattern="[0,9]{0,8}"
															autoComplete="off"
															min={0}
															max={99999999}
															maxLength={8}
															className={`form-control ${formErrors && formErrors.employeeID ? "has-error" : ""}`}
															value={editObj && editObj.employeeID ? editObj.employeeID : ""}
															onKeyDown={checkEmployeeIDLength}
															onChange={(e) => handleInputChange("employeeID", e.target.value)}
														/>
														{formErrors && formErrors.employeeID ? (
															<div className="customer-error-msg">
																<p>{formErrors.employeeID}</p>
															</div>
														) : ''}
													</div>
												</div>
											</div>
										</div>
									</fieldset>
									<div className="row">
										<div className="col-sm-12">
											<div className="form-group row">
												<label htmlFor="LastSeen" className="col-sm-4 col-form-label shrink-label">Last Seen</label>
												<div className="col-sm-8">
													<span className="form-control disabled">{user.lastLogin ? convertUTCToLocalDateTime(user.lastLogin) : "N/A"}</span>
												</div>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-sm-12">
											<div className="form-group row">
												<label htmlFor="DateCreated" className="col-sm-4 col-form-label shrink-label">Date Created</label>
												<div className="col-sm-8">
													<span className="form-control disabled"> {user.userCreatedDate ? convertUTCToLocalDateTime(user.userCreatedDate) : "N/A"} </span>
												</div>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-sm-12 text-end">
											{!editMode ? <>
												<button type="button" id="edit-btn" className="btn btn-primary case-action-btn me-0" onClick={toggleEditMode}>Edit</button>
												<button type="button" className="btn btn-secondary ms-2" id="cancel" onClick={handleCancel}> Close</button>
											</> : <>
												<button type="button" id="save-btn" className="btn btn-primary case-action-btn" onClick={saveUser}>Save</button>
												<button type="button" id="cancel-btn" className="btn btn-secondary me-0" onClick={this.cancelEdit}>Cancel</button>
											</>}
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				) : (
					<div className="customer-fields">
						<div className="case-details-container">
							<div className="card-body" data-testid="error-block">
								{userSaveError ? <ErrorMsgBlockComponent errorObject={userSaveError} /> : <ErrorMsgBlockComponent noData={true} />}
							</div>
						</div>
					</div>
				)}
			</>
		);
	}
}

export default MappedUserDetails;